import { APIS } from "../../../../../utils/api-factory";
import {
  CUSTOM_NEW_HEADER,
  CUSTOM_NEW_MULTIPART_HEADER,
  CUSTOM_NEW_MULTIPART_HEADER_WITHOUT_KEY,
  POST_HEADER,
  TENANT_BRE_POST_HEADER,
  TENANT_HEADER,
} from "../../../../../utils/apiHeaders";
import axios from "axios";

// export const fetchGstSummaryDetails = (data, callBack, error) => {
//   axios
//     .post(APIS.FETCH_GST_SUMMARY_BY_PAN, data, CUSTOM_NEW_HEADER)
//     .then((res) => {
//       callBack(res?.data);
//     })
//     .catch((e) => {
//       callBack("");
//     });
// };
export const fetchGstSummaryDetails = (pan,userId, callBack, error) => {
  axios
    .post(APIS.GET_PAN_TO_GST_DETAILS_BYPAN + pan + '&userId=' + userId, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getKycVerificationByUserId = (id, callBack, error) => {
  axios
    .get(APIS.GET_KYC_VERIFICATION_BY_USERID + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getKycVerificationByUserIdNew = (id, callBack, error) => {
  axios
    .get(APIS.GET_KYC_VERIFICATION_BY_USERID_NEW + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getUserDetailsAddressUpdatedByUserId = (id, callBack, error) => {
  axios
    .get(APIS.GET_USER_ADDRESS_DETAILS_UPDATED_BY_USERID + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const uploadCreditAssessmentData = (id, data, callBack, error) => {
  axios
    .post(
      APIS.UPLOAD_CREDIT_ASSESMENT_DATA + id + "/upload",
      data,
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const uploadCrifAssessmentData = (id, data, callBack, error) => {
  axios
    .post(
      APIS.UPLOAD_CRIF_ASSESMENT_DATA + id + "/upload",
      data,
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const  getGstAuthenticatiobByData = (data, callBack, error) => {
  axios
    .post(APIS.GET_GST_AUTHENTICATION_BY_DATA, data, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const  getGstAuthenticatiobByDataNew = (gst, callBack, error) => {
  axios
    .post(APIS.GET_GST_AUTHENTICATION_BY_DATA_NEW_NEW +  gst,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getCReditRelatedData = (id, callBack, error) => {
  axios
    .get(APIS.GET_CREDIT_RELATED_DATA + id, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getCRifRelatedData = (id, callBack, error) => {
  axios
    .get(APIS.GET_CRIF_ANALYSIS_RELATED_DATA + id, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getCreditLoanApplicationData = (id, callBack, error) => {
  axios
    .get(APIS.GET_CREDIT_LOAN_APPLICATION_DATA + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getProductJunctionDetailsByLoanAmountAndTenure = (loanType, loanAmount, tenure, callBack, error) => {
  axios.get(APIS.GET_PRODUCT_JUNCTION_DETAILS_BY_LOAN_AMOUNT_AND_TENURE + `?loanType=${loanType}&loanAmount=${loanAmount}&tenure=${tenure}`)
    .then(res => {
      callBack(res?.data)
    })
    .catch(e => {
      callBack("")
    })
};
export const saveLoanSummaryAPI = (data, callBack, error) => {
  axios.post(APIS.SAVE_LOAN_SUMMARY , data, POST_HEADER)
    .then(res => {
      callBack(res?.data)
    })
    .catch(e => {
      callBack(null)
    })
};
export const downlaodCreditAssessmentTempalte = (callBack, error) => {
  axios
    .get(APIS.DOWNLOAD_CREDIT_ASSESSMENT_TEMPLATE, {
      ...CUSTOM_NEW_HEADER,
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Credit_Assessment_Template.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(res);
    })
    .catch((e) => {
      console.error(e);
      error && error(e);
    });
};
export const downlaodUploadedExcelTempalte = (id,callBack, error) => {
  axios
    .get(APIS.DOWNLOAD_UPLADED_EXCEL_TEMPLATE + id + '/download', {
      ...CUSTOM_NEW_HEADER,
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Credit_Assessment_Uploaede.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(res);
    })
    .catch((e) => {
      console.error(e);
      callBack && callBack(e);
    });
};
export const downlaodCrifAssessmentTempalte = (callBack, error) => {
  axios
    .get(APIS.DOWNLOAD_CRIF_ASSESSMENT_TEMPLATE, {
      ...CUSTOM_NEW_HEADER,
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Crif_Assessment_Template.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(res);
    })
    .catch((e) => {
      console.error(e);
      error && error(e);
    });
};
export const downlaodBankingAssessmentTempalte = (callBack, error) => {
  axios
    .get(APIS.DOWNLOAD_BANKING_ASSESSMENT_TEMPLATE, {
      ...CUSTOM_NEW_HEADER,
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Crif_Assessment_Template.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      callBack && callBack(res);
    })
    .catch((e) => {
      console.error(e);
      error && error(e);
    });
};
export const uploadBankingAssessmentData = (id, data, callBack, error) => {
  axios
    .post(
      APIS.UPLOAD_BANKING_ASSESMENT_DATA + id + "/upload",
      data,
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getBankingData = (id, callBack, error) => {
  axios
    .get(APIS.GET_BANKING_DATA + id, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getBankingInstitutionList = (callBack, error) => {
  axios
    .get(APIS.GET_BANKING_INSTITUTION_LIST, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const inititateBank = (userId, data, callBack, error) => {
  axios
    .post(
      `${APIS.INITIATE_BANKING_BY_USERID}/${userId}/initiate`,
      data,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const uploadBankingTransactionPdfData = (id, data, callBack, error) => {
  axios
    .post(
      APIS.UPLOAD_BANK_TRANSACTION_PDF_BY_CLIENT_TRANSACTION_ID +
        id +
        "/upload",
      data,
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getBureauInstitutionList = (callBack, error) => {
  axios
    .get(APIS.GET_BUREAU_INSTITUTION_LIST, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const inititateBureauByUserId = (userId, data, callBack, error) => {
  axios
    .post(
      `${APIS.INITIATE_BUREAU_BY_USERID}/${userId}/initiate`,
      data,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const uploadBureauTransactionPdfData = (id, data, callBack, error) => {
  axios
    .post(
      APIS.UPLOAD_BUREAU_TRANSACTION_PDF_BY_CLIENT_TRANSACTION_ID +
        id +
        "/upload",
      data,
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const processBureauUploadedPdfByClientTransactionId = (
  clientTransactionId,
  data,
  callBack,
  error,
) => {
  axios
    .post(
      `${APIS.PROCESS_BUREAU_UPLOADED_PDF_BY_CLIENT_TRANSACTION_ID}${clientTransactionId}/process`,
      data,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getBureauReportData = (id, callBack, error) => {
  axios
    .get(
      `${APIS.GET_BUREAU_REPORT_DATA_BY_USERID}/${id}/report?types=json`,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getBankReportData = (id, callBack, error) => {
  axios
    .get(
      `${APIS.GET_BANK_REPORT_DATA_BY_USERID}/${id}/report?types=json`,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getProductTypeList = (callBack, error) => {
  axios
    .get(`${APIS.GET_PRODUCT_TYPES_LIST}`)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getSubProductTypeList = (type,callBack, error) => {
  axios
    .get(APIS.GET_SUB_PRODUCT_TYPES_LIST + type)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getStatusTypeListCredit = (callBack, error) => {
  axios
    .get(`${APIS.GET_STATUS_TYPES_LIST_FOR_CREDIT}`)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const ValidateProductCreditLine = (data, callBack, error) => {
  axios
    .post(APIS.VALIDATE_PRODUCT_DRAWDOWN_FOR_CREDIT_LINE, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const createProductCreditLine = (data, callBack, error) => {
  axios
    .post(APIS.CREATE_PRODUCT_DRAWDOWN_FOR_CREDIT_LINE, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const updateCreditLineStatusById = (data, callBack, error) => {
  axios
    .post(APIS.UPDATE_STATUS_CREDIT_LINE_LIST_BY_ID, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getActivecreditLineListById = (id, callBack, error) => {
  axios
    .get(APIS.GET_ACTIVE_CREDIT_LINE_LIST_BY_ID + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getHistorycreditLineListById = (id, callBack, error) => {
  axios
    .get(APIS.GET_HISTORY_CREDIT_LINE_LIST_BY_ID + id + "/history")
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};
export const getReqestedamountData = (id, callBack, error) => {
  axios
    .get(APIS.GET_REQUESTED_AMOUNT_DATA + id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      callBack("");
    });
};

export const getAllUploadedDocumentsListForProcessByUserId = (
  id,
  callBack,
  error,
) => {
  axios
    .get(
      APIS.GET_ALL_UPLOADED_DOCUMENTS_LIST_FOR_PROCESS_BY_USER_ID +
        id +
        "/files",
      CUSTOM_NEW_MULTIPART_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const processBankingFile = (
  clientTransactionId,
  data,
  callBack,
  error,
) => {
  axios
    .post(
      `${APIS.PROCESS_BANKING_UPLOADED_PDF_BY_CLIENT_TRANSACTION_ID}${clientTransactionId}/process`,
      data,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const getStateForBankingByUserId = (userId, callBack, error) => {
  axios
    .get(
      `${APIS.GET_STATE_FOR_BANKING_INSTITUTION}${userId}/state`,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const getStateForBureauByUserId = (userId, callBack, error) => {
  axios
    .get(
      `${APIS.GET_STATE_FOR_BUREAU_INSTITUTION}${userId}/state`,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const getInitialReviewStatusByUserid = (userId, callBack, error) => {
  axios
    .get(`${APIS.GET_INITIAL_REVIEW_STATUS_BY_USERID}${userId}`)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const setInitialReviewStatusByUserid = (
  userId,
  status,
  callBack,
  error,
) => {
  axios
    .post(
      `${APIS.SET_INITIAL_REVIEW_STATUS_BY_USERID}${userId}&initialReviewStatus=${status}`,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};


export const saveLoanParticularsSection = (
  userId,
  payload,
  callBack,
  error,
) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/loan-summary`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveIndividualSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/individuals`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const SaveUpdateIndivudlas = (payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_UPDATE_INDIVUDALS}`,
      payload,
      POST_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveBusinessSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/business-kyc`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const saveBusinessSectionNew = ( payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_BUINSESS_DETAILS_SECTION}`,
      payload,
      POST_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveManagementSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/management-profile`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveScfAnalysisSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/scf-analysis`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveBankStatementSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/bank-statement`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveGstProfileSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/gst-profile`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveCreditEligibilitySection = (
  userId,
  payload,
  callBack,
  error,
) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/credit-eligibility`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const saveRecommendationSection = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.SAVE_CREDIT_DATA}${userId}/recommendation`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const SaveCommentListApi = (userId, payload, callBack, error) => {
  axios
    .post(
      `${APIS.GET_COMMENT_LIST}${userId}`,
      payload,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};
export const getCommentListApi = (userId, callBack, error) => {
  axios
    .get(
      `${APIS.GET_COMMENT_LIST}${userId}`,
      CUSTOM_NEW_HEADER,
    )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

export const getAllCreditData = (userId, callBack, error) => {
  axios
    .get(`${APIS.SAVE_CREDIT_DATA}${userId}`, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};


export const verifyPanNumberByUserId = (data, callBack, error) => {
  axios
    .post(APIS.VERIFY_PAN_NUMBER_BY_USER_ID, data, POST_HEADER)
    .then((res) => {
      console.log('fbvhjcnk', res)
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}


export const deleteApplicantByUserId = (userId, callBack, error) => {
  axios
    .post(`${APIS.DELETE_APPLICANT_BY_USER_ID}${userId}`,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}

export const recoverDeletedApplicantByUserId = (userId, callBack, error) => {
  axios
    .post(`${APIS.RECOVER_DELETED_APPLICANT_BY_USER_ID}${userId}`, {} ,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const getCommitteeStatusByUseId = (userId, callBack, error) => {
  axios
    .get(`${APIS.GET_COMMITTE_STATUS_BY_USERID}${userId}`)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const SaveCommitteeStatusByUseId = (data, callBack, error) => {
  axios
    .post(`${APIS.SET_COMMITTE_STATUS_BY_USERID}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const SaveCommitteeLevel1Status = (data, callBack, error) => {
  axios
    .post(`${APIS.SET_COMMITTE_LEVEL1_STATUS}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      if (error) error(e);
    });
} 
export const SaveCommitteeLevel2Status = (data, callBack, error) => {
  axios
    .post(`${APIS.SET_COMMITTE_LEVEL2_STATUS}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      if (error) error(e);
    });
} 
export const SaveCommitteeLevel3Status = (data, callBack, error) => {
  axios
    .post(`${APIS.SET_COMMITTE_LEVEL3_STATUS}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      if (error) error(e);
    });
} 
export const SaveCreditLineRecommendationLoanUtility = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_CREDIT_LINE_RECOMMNEDATION_LOAN_UTLITY}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const SaveCreditLineRecommendationProcessingFees = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_CREDIT_LINE_RECOMMNEDATION_PROCESSIGN_FEES}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const SaveCreditLineRecommendationSubvention = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_CREDIT_LINE_RECOMMNEDATION_SUBVENTION}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const GetCreditLineRecommendationSubvention = (data, callBack, error) => {
  axios
    .post(`${APIS.GET_CREDIT_LINE_RECOMMNEDATION_SUBVENTION}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const GetListCreditLineSubvention = (TYPE, callBack, error) => {
  axios
    .get(`${APIS.GET_LIST_CREDIT_LINE_SUBVENTION}${TYPE}`)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 
export const GetExtractProductDataByData = (data, callBack, error) => {
  axios
    .post(`${APIS.GET_EXTRACT_PRRODUCT_BY_DATA}`,data,POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
} 

// POST API to save bank statement comment using POST_HEADER
export const saveBankStatementComment = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_BANK_STATEMENT_COMMENT}`, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

// GET API to fetch bank statement comment using CUSTOM_NEW_HEADER
export const getBankStatementComment = (userId, callBack, error) => {
  axios
    .get(`${APIS.GET_BANK_STATEMENT_COMMENT}${userId}`, CUSTOM_NEW_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

// POST API to save adhoc limit using POST_HEADER
export const saveAdhocLimit = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_ADHOC_LIMIT}`, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const SaveSanctionLineUpdate = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_SANCTION_LIMIT_CREDITLINE}`, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const saveFinancialSummaryApi = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_FINANICLA_SUMMARY_API}`, data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const getFinancialListAPi = (id, callBack, error) => {
  axios
    .get(`${APIS.GET_COMMENT_LIST}`+ id)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const SaveProcessingFeeCreditLine = (data, callBack, error) => {
  axios
    .post(`${APIS.SAVE_PROCESSINGFEE_CREDIT_LINE}`,data, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const UpdateProcessingFeeCreditLineStatus = (id,status, callBack, error) => {
  axios
    .put( APIS.SAVE_PROCESSINGFEE_CREDIT_LINE + '/' + id + '/status',status, POST_HEADER)
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
}; 
export const GetProcessingFeeCreditLineData = (id,status, callBack, error) => {
  axios
    .get( APIS.SAVE_PROCESSINGFEE_CREDIT_LINE + '/' + id )
    .then((res) => {
      callBack(res?.data);
    })
    .catch((e) => {
      error(e);
    });
};

// ── PDC APIs ────────────────────────────────────────────────────────

// POST /credit-sanction/pdc
export const AddPDC = (data, callBack, error) => {
  axios
    .post(`${APIS.PDC_BASE}`, data, POST_HEADER)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// PUT /credit-sanction/pdc/{id}
export const UpdatePDC = (id, data, callBack, error) => {
  axios
    .put(`${APIS.PDC_BASE}/${id}`, data, POST_HEADER)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// PUT /credit-sanction/pdc/{id}/status
export const UpdatePDCStatus = (id, data, callBack, error) => {
  axios
    .put(`${APIS.PDC_BASE}/${id}/status`, data, POST_HEADER)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// GET /credit-sanction/pdc/credit-line/{creditLineId}
export const GetPDCByCreditLine = (creditLineId, callBack, error) => {
  axios
    .get(`${APIS.PDC_BASE}/credit-line/${creditLineId}`)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// POST /credit-sanction/pdc/{id}/upload-image  (multipart)
export const UploadPDCImage = (id, file, callBack, error) => {
  const formData = new FormData();
  formData.append('file', file);
  axios
    .post(`${APIS.PDC_BASE}/${id}/upload-image`, formData, CUSTOM_NEW_MULTIPART_HEADER_WITHOUT_KEY)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// DELETE /credit-sanction/pdc/{id}
export const DeletePDC = (id, callBack, error) => {
  axios
    .delete(`${APIS.PDC_BASE}/${id}`)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};
export const PushToLmsAPICreditLine = (id, callBack, error) => {
  axios
    .post(`${APIS.PUSH_TO_LMS_CREDIT_LINE}${id}/push-to-lms`)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};
export const UploadDocumentsCreditLine = (id,data, callBack, error) => {
  axios
    .post(`${APIS.UPLOAD_DCOUMENT_SIGNED_LETTERS}${id}/upload-documents`,data, CUSTOM_NEW_MULTIPART_HEADER_WITHOUT_KEY)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};
export const GetUploadDocumentsCreditLine = (id, callBack, error) => {
  axios
    .get(`${APIS.UPLOAD_DCOUMENT_SIGNED_LETTERS}${id}/upload-documents`)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// ── Financial Performance Analysis ─────────────────────────
export const saveFinancialPerformance = (payload, callBack, error) => {
  axios
    .post(APIS.SAVE_FINANCIAL_PERFORMANCE, payload, POST_HEADER)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

export const getFinancialPerformance = (loanId, callBack, error) => {
  axios
    .get(`${APIS.GET_FINANCIAL_PERFORMANCE}?loanId=${loanId}`)
    .then((res) => { callBack(res?.data); })
    .catch((e) => { if (error) error(e); });
};

// ── Recommendation & Committee Decision APIs (GET & POST) ──────────────
export const getRecommendationSectionDetails = (loanId, userId, callBack, error) => {
  const url = `${APIS.GET_RECOMMENDATION_SECTION_DETAILS}?loanId=${encodeURIComponent(loanId || "")}&userId=${encodeURIComponent(userId || "")}`;
  axios
    .get(url, CUSTOM_NEW_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error getting recommendation details:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const saveRecommendationSectionNew = (payload, callBack, error) => {
  axios
    .post(APIS.SAVE_RECOMMENDATION_SECTION_DETAILS, payload, POST_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error saving recommendation details:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const saveCommitteeDecisionNew = (payload, callBack, error) => {
  axios
    .post(APIS.SAVE_COMMITTEE_DECISION_DETAILS, payload, POST_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error saving committee decision:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

// ── CIBIL Score & DBR Details (BRE APIs) ──────────────────────────────
export const getCibilScoreDataByUserIdLoanId = (userId, loanId, callBack, error) => {
  const url = `${APIS.GET_CIBIL_SCORE_BY_USERID}${encodeURIComponent(userId || "")}&loanId=${encodeURIComponent(loanId || "")}&fetchBy=loan`;
  axios
    .get(url, TENANT_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error getting CIBIL score data:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const getDbrDetailsByUserId = (userId, callBack, error) => {
  const url = `${APIS.GET_DBR_ALL_DATA}${encodeURIComponent(userId || "")}`;
  axios
    .get(url, TENANT_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error getting DBR details:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

// ── Bank Statement Analysis API (GET & POST) ─────────────────────────
export const getBankStatementAnalysis = (loanId, callBack, error) => {
  const url = `${APIS.BASE_URL}api/v1/loan-application/bank-statement-analysis?loanId=${encodeURIComponent(loanId)}`;
  axios
    .get(url)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error getting bank statement analysis:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const saveBankStatementAnalysis = (payload, callBack, error) => {
  const url = `${APIS.BASE_URL}api/v1/loan-application/bank-statement-analysis`;
  axios
    .post(url, payload, POST_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error saving bank statement analysis:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

// ── Credit Profile API (GET & POST) ─────────────────────────
export const getCreditProfile = (loanId, callBack, error) => {
  const baseUrl =  APIS.CREDIT_PROFILE_API;
  const url = `${baseUrl}?loanId=${encodeURIComponent(loanId)}`;
  axios
    .get(url)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error getting credit profile:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const saveCreditProfile = (payload, callBack, error) => {
  const baseUrl =  APIS.BASE_URL;
  const url = `${baseUrl}api/credit-profile`;
  axios
    .post(url, payload, POST_HEADER)
    .then((res) => {
      if (callBack) callBack(res?.data);
    })
    .catch((e) => {
      console.error("Error saving credit profile:", e);
      if (error) error(e);
      else if (callBack) callBack(null);
    });
};

export const fetchCrifReportHtml = (userId, regenerateParam, loanId,emailId, callBack) => {
  const url = `${APIS.GET_CRIF_DATA}${userId}&regenerateParam=${regenerateParam}&loanId=${loanId}&empId=${emailId}`;
  fetch(url,TENANT_HEADER)
    .then((res) => res.text())
    .then((res) => {
      if (callBack) callBack(res);
    })
    .catch((err) => {
      console.error("Error fetching CRIF data:", err);
      if (callBack) callBack("");
    });
};
export const fetchCrifReportHtmlNew = (userId, regenerateParam,emailId, callBack) => {
  const url = `${APIS.GET_CRIF_DATA}${userId}&regenerateParam=${regenerateParam}&empId=${emailId}`;
  fetch(url,TENANT_HEADER)
    .then((res) => res.text())
    .then((res) => {
      if (callBack) callBack(res);
    })
    .catch((err) => {
      console.error("Error fetching CRIF data:", err);
      if (callBack) callBack("");
    });
};
export const getLoanApprovalScorngById = (userId,  callBack) => {
  const url = `${APIS.GET_LOAN_APPROVAL_SCORING_BY_USERID}${userId}`;
  fetch(url,TENANT_HEADER)
    .then((res) => res.json())
    .then((res) => {
      if (callBack) callBack(res);
    })
    .catch((err) => {
      console.error("Error fetching CRIF data:", err);
      if (callBack) callBack("");
    });
};
export const UpdateLoanApprovalScorngById = (data,  callBack) => {
  const url = `${APIS.UPDATE_LAON_SCORING_BY_DATA}`;
  fetch(url,{
    method:"PUT",
    body:JSON.stringify(data),
    headers:TENANT_BRE_POST_HEADER
  })
    .then((res) => res.text())
    .then((res) => {
      if (callBack) callBack(res);
    })
    .catch((err) => {
      console.error("Error fetching CRIF data:", err);
      if (callBack) callBack("");
    });
};
export const getBureauCheckDataByUserId = (userId, callBack) => {
  const url = `${APIS.BUREAU_CHECK}${userId}`;
  fetch(url, TENANT_HEADER)
    .then((res) => res.json())
    .then((res) => {
      if (callBack) callBack(res);
    })
    .catch((err) => {
      console.error("Error fetching Bureau Check data:", err);
      if (callBack) callBack(null);
    });
};

export const generateGstAnalyticsOtpApi = ({ gstin, gstPortalUsername, reportStartYear, numberOfYears }, callBack, errorCallBack) => {
  const baseUrl = (APIS.DIGITAP_GST_GENERATE_OTP || "http://localhost:8070/bank-verification/digitap/gst-analytics/generate-otp");
  const query = `?gstin=${encodeURIComponent(gstin || "")}&gstPortalUsername=${encodeURIComponent(gstPortalUsername || "")}&reportStartYear=${encodeURIComponent(reportStartYear || "")}&numberOfYears=${encodeURIComponent(numberOfYears || 1)}`;
  const fullUrl = `${baseUrl}${query}`;

  axios
    .post(fullUrl, {}, POST_HEADER)
    .then((res) => {
      callBack && callBack(res?.data);
    })
    .catch((err) => {
      console.error("Error generating GST OTP:", err);
      errorCallBack && errorCallBack(err);
      callBack && callBack(err?.response?.data || { success: false, message: err?.message || "Failed to generate OTP" });
    });
};

export const submitGstAnalyticsOtpApi = ({ requestId, otp }, callBack, errorCallBack) => {
  const baseUrl = (APIS.DIGITAP_GST_SUBMIT_OTP || "http://localhost:8070/bank-verification/digitap/gst-analytics/submit-otp");
  const query = `?requestId=${encodeURIComponent(requestId || "")}&otp=${encodeURIComponent(otp || "")}`;
  const fullUrl = `${baseUrl}${query}`;

  axios
    .post(fullUrl, {}, POST_HEADER)
    .then((res) => {
      callBack && callBack(res?.data);
    })
    .catch((err) => {
      console.error("Error submitting GST OTP:", err);
      errorCallBack && errorCallBack(err);
      callBack && callBack(err?.response?.data || { success: false, message: err?.message || "Failed to submit OTP" });
    });
};

export const getGstAnalyticsStatusApi = ({ requestId }, callBack, errorCallBack) => {
  const baseUrl = (APIS.DIGITAP_GST_STATUS || "http://localhost:8070/bank-verification/digitap/gst-analytics/status");
  const query = `?requestId=${encodeURIComponent(requestId || "")}`;
  const fullUrl = `${baseUrl}${query}`;

  axios
    .post(fullUrl, {}, POST_HEADER)
    .then((res) => {
      callBack && callBack(res?.data);
    })
    .catch((err) => {
      console.error("Error checking GST Analytics status:", err);
      errorCallBack && errorCallBack(err);
      callBack && callBack(err?.response?.data || { success: false, message: err?.message || "Failed to fetch status" });
    });
};

export const getPreviousGstReportByGstinApi = ({ gstin }, callBack, errorCallBack) => {
  const baseUrl = (APIS.DIGITAP_GST_REPORT_LINKS || APIS.DIGITAP_GST_FETCH_PREVIOUS || "http://localhost:8070/bank-verification/digitap/gst-analytics/report-links");
  const query = `?gstin=${encodeURIComponent(gstin || "")}`;
  const fullUrl = `${baseUrl}${query}`;

  // Execute GET request as per curl specification
  axios
    .get(fullUrl, POST_HEADER)
    .then((res) => {
      callBack && callBack(res?.data);
    })
    .catch((err) => {
      // Fallback: try GET without custom headers in case of header constraints
      axios
        .get(fullUrl)
        .then((res) => {
          callBack && callBack(res?.data);
        })
        .catch((getErr) => {
          console.error("Error fetching previous GST report links by GSTIN:", getErr);
          errorCallBack && errorCallBack(getErr);
          callBack && callBack(getErr?.response?.data || { success: false, message: getErr?.message || "Failed to fetch previous analysis report" });
        });
    });
};